import { CARDS } from '../actions/types';
import createReducer from './createReducer';

const reduceCards = {
  [CARDS.RECEIVED]: (prevState, payload) => payload,
  [CARDS.FAILED]: () => 'unknown error',
  [CARDS.REQUEST_FAILED]: () => 'unknown error',
};

export default createReducer(null, reduceCards);
